import React, { Component } from 'react';
let styles = require('../../css_modules/helpModal.less');
import classNames from 'classnames';

export default class PopupDialog extends Component {
    render() {
        const classes = "modal wide-modal " + styles.helpModal;
        return (
            <div style={{display: 'block'}} className={classes} tabIndex="-1" role="dialog">
                <div className={classNames('modal-dialog', styles['modal-dialog'])}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{this.props.title}</h4>
                            <button
                                type="button"
                                className="btn btn-close"
                                data-dismiss="modal"
                                style={{float: "right"}}
                                onClick={this.props.onClose}/>
                        </div>

                        <div className={classNames('modal-body', styles['modal-body'])}
                             style={{background: this.props.backgroundColor || "#364356", height: "auto", padding: "15px 10px"}}>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/modal/PopupDialog.js